import { render, staticRenderFns } from "./UserDeleteModal.vue?vue&type=template&id=7bb6c1a5&scoped=true"
import script from "./UserDeleteModal.vue?vue&type=script&lang=js"
export * from "./UserDeleteModal.vue?vue&type=script&lang=js"
import style0 from "./UserDeleteModal.vue?vue&type=style&index=0&id=7bb6c1a5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bb6c1a5",
  null
  
)

export default component.exports